// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"00822f85","168":"8a6cb722","181":"b8f50397","204":"34ba059d","213":"961af0ea","227":"c4af0a38","245":"736de746","482":"988c607c","488":"15a61091","538":"922f5d7d","615":"0ead2186","624":"2ef55a2f","724":"2f2f699d","811":"f6e4e18b","897":"d0aeae98"}[chunkId] + ".chunk.js";
};